import type { RootState } from '../types';

const EMPTY_ARRAY: readonly never[] = [];

export const warehousesSelectors = {
  basicList: (state: RootState) =>
    state.warehouses.basicWarehouses || EMPTY_ARRAY,
  basicTerminalsList: (state: RootState) =>
    state.warehouses.basicTerminals || EMPTY_ARRAY,
  selectedWarehouseId: (state: RootState) =>
    state.warehouses.selectedWarehouseId,
};
